import React from 'react';
import { Box, Container } from '@chakra-ui/react';
import { DataUploadView } from 'src/features/DataUpload/components/templates/DataUploadView';

export const DataUploadPage: React.FC = () => {
  return (
    <Box color="content.body" w="100%" minH="70vh">
      <Container maxW="100%" px={12} py={8}>
        <Box maxW="100%">
          <DataUploadView />
        </Box>
      </Container>
    </Box>
  );
};
